import * as React from 'react'
import { ReactElement } from 'react'
import ComposeOutlookItemDialog, { ComposeOutlookItemDialogProps } from './ComposeOutlookItemDialog'
import { outlookDisplayNewAppointmentForm } from '../../../helpers/outlookHelper'
import AsyncResultStatus = Office.AsyncResultStatus
import { useTranslation } from 'react-i18next'

export type ComposeAppointmentDialogProps = Omit<ComposeOutlookItemDialogProps, 'onCompose' | 'submitText'> & {
    callback?: () => void
}

export default function ComposeAppointmentDialog(props: ComposeAppointmentDialogProps): ReactElement {
    const { t: translate } = useTranslation()

    return (
        <ComposeOutlookItemDialog
            submitText={translate('action.create.appointment')}
            dialogContentProps={{ title: translate('action.create.appointment') }}
            {...props}
            onCompose={(recipients: string[], subject: string) =>
                outlookDisplayNewAppointmentForm(
                    { requiredAttendees: recipients, subject },
                    (asyncResult?: Office.AsyncResult<void>) => {
                        if (!asyncResult || asyncResult?.status === AsyncResultStatus.Succeeded) {
                            props.callback?.()
                            props.onDismiss()
                        }
                    },
                )
            }
        />
    )
}
